import * as React from 'react'
import { Link } from 'gatsby'
import { node } from '@/src/types/post'
import * as styles from '@/src/components/post/ListItem.module.scss'

const ListItem = ({ node }) => {
  return (
    <li className={styles.listItem}>
      <div className={styles.top}>
        <p className={styles.title}>
          <Link to={node.slug}>{node.frontmatter.title}</Link>
        </p>
        <p className={styles.date}>{node.frontmatter.date}</p>
      </div>
      <p className={styles.excerpt}>{node.excerpt}</p>
    </li>
  )
}

ListItem.propTypes = {
  node
}

export default ListItem
